module.exports = __webpack_public_path__ + "static/media/nail.0a8a5eff.svg";